import { render, staticRenderFns } from "./ReservationDetailsMessages.vue?vue&type=template&id=065fb42a&scoped=true&"
import script from "./ReservationDetailsMessages.vue?vue&type=script&lang=js&"
export * from "./ReservationDetailsMessages.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "065fb42a",
  null
  
)

export default component.exports